export const Endpoints = {
  ATTR_DATA: "api/articulos/all",
  BALANCE_RESUME: "/solicita-resumen",
  CANCEL_ORDER: "api/pedidos/anular",
  CANCEL_QUOTE: "api/cotizaciones/anular/",
  CLIENTS: "api/clientes",
  CLIENTS_PARAMETERS: "api/parametros",
  CLIENTS_WITH_PARAMETERS: "api/clientes",
  CONFIGURATION_BY_USER: "api/parametros/byUser/",
  CONFIGURATION_PARAMS: "api/parametros",
  DATER: "api/fechadores",
  DATER_GO_UP: "api/fechadores/subirElemento",
  DATER_GO_DOWN: "api/fechadores/bajarElemento",
  DOWNLOAD_USEFUL_FILE: "api/archivos-utiles",
  GET_LOGO_UPLOADS: "api/uploads/",
  GET_PDF_CLIENTE: "api/cotizaciones/pdf-cliente/",
  GET_PDF_CLIENTE_WITH_ATTRIBUTES: "api/cotizaciones/pdf-cliente-with-attributes/",
  GET_PDF_EXPEDICION: "api/pedidos/pdf-distribuidor/expedicion/",
  GET_PDF_FACTURACION: "api/pedidos/pdf-distribuidor/",
  GET_PDF_USUARIO: "api/cotizaciones/pdf-distribuidor-cliente/",
  GET_PDF_USUARIO_WITH_ATTRIBUTES: "api/cotizaciones/pdf-distribuidor-cliente-with-attributes/",
  GET_PRODUCT_COMPLETE_DATA: "api/v2/products",
  LOGIN: "api/login",
  ORDERS_DRAFT_SEARCH: "api/pedidos?is_borrador=true",
  ORDERS_SEARCH_FROM_LIST: "api/pedidos",
  ORDERS_SEARCH: "api/pedidos?is_borrador=false",
  PRICES_LIST: "api/listas-de-precios/vigente",
  PRODUCT_ATTR: "api/productos/atributosItems",
  PRODUCT_CHILD: "api/productos/productosHijos",
  PRODUCT_COMPLEMENTS: "api/productos/complementosNecesarios",
  PRODUCT_SEARCH: "api/productos/findBy",
  PRODUCT_SEARCH_BY_ID: "api/productos",
  PRODUCT_SELECT: "api/productos/byGrupo",
  PROFILE: "api/security/profile",
  QUOTE_SEARCH: "api/cotizaciones",
  RUBRO: "api/grupos/cotizables",
  RESET: "api/users/password/reset",
  RECOVER: "api/users/password/recover",
  SAVE_GET_QUOTE: "api/cotizaciones",
  SAVE_ORDER: "api/pedidos",
  UPLOAD_LOGO: "api/upload/",
  UPDATE_ORDER: "api/pedidos/update/",
  UPDATE_QUOTE: "api/cotizaciones/update/",
  USER: "api/clientes/usuario",
  USEFUL_FILES: "api/archivos-utiles",
  FOLDERS: "api/folder",
  GET_PRODUCT_PRICE_BASE: "api/calculadora",
  DELETE_PRODUCT_FROM_ORDER: "api/pedidos/eliminarItem"
};
